import type { TextListItem } from '@atlas/ui-domain'
import { MESSAGE_TYPE_LABEL, type Message } from '@/domain/message.types'

/**
 * A Message as `TextListCard` states it.
 *
 * The message type is resolved to its label here, so the card never has to know a type the
 * taxonomy grew. The title becomes the row's NAME: it carries the text's placement in the piece
 * (`d3_c1_title`), which is what makes a row identifiable alongside its type.
 */
export const toTextListItem = (message: Message): TextListItem => ({
	id: message.messageId,
	locale: message.languageIso,
	isSourceLocale: message.isSource,
	typeLabel: MESSAGE_TYPE_LABEL[message.messageType],
	name: message.title,
	content: message.content,
})

export const toTextListItems = (messages: Message[]): TextListItem[] => messages.map(toTextListItem)
